import React, { useEffect, useRef } from "react";
import "./LottieLoaderanim.css";

// This component is the app-wide Suspense fallback (rendered synchronously
// on every route, before any lazy route chunk has loaded), so lottie-web
// and the animation JSON (~1MB combined) are dynamically imported here
// instead of statically - otherwise they ship in the eager/initial bundle
// on every page load just to render a loading spinner.
function LottieLoaderanim() {
  const animationLoader = useRef(null);
  useEffect(() => {
    let anim;
    let cancelled = false;
    Promise.all([
      import("lottie-web"),
      import("../../Assets/lottie/LottieLoader.json"),
    ]).then(([lottieModule, animationData]) => {
      if (cancelled) return;
      anim = lottieModule.default.loadAnimation({
        container: animationLoader.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData.default,
      });
    });
    return () => {
      cancelled = true;
      anim && anim.destroy();
    };
  }, []);
  return (
    <div className="ResponsiveLottie">
      <div
        id="loader_lottie"
        ref={animationLoader}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}

export default LottieLoaderanim;
